__webpack_require__.p = "/budget_app-react/";